import { ClvrPrscPosologyFrequencyOptionType } from '../ClvrPrscPosologyFrequencySelector/types'

export const CLVR_PRSC_UNIQ_ORDER_FREQUENCY_OPTION_ID = -1

export const CLVR_PRSC_UNIQ_ORDER_FREQUENCY_OPTION: ClvrPrscPosologyFrequencyOptionType = {
    id: CLVR_PRSC_UNIQ_ORDER_FREQUENCY_OPTION_ID,
    label: 'prescriptionClevEHR:prescriptionClevEHR-prsc_uniq_order-frequency-title',
}
